/**
 * 填空题
 */
import QuestionFillin from './view';

export default QuestionFillin;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/fillin/index.js